import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom"

export const useCustomSearchParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const customSearchParams = useMemo(() => {
        const obj = {};

        searchParams.forEach((value, key) => {
            obj[key] = value;
        });

        return obj;
    }, [searchParams]);

    const setCustomSearchParams = useCallback((input, options = {}) => {
        const cleaned = buildSearchParamsObject(input);

        setSearchParams(cleaned, {
            replace: options.replace ?? false,
        });
  }, [setSearchParams]);

  return {customSearchParams, setCustomSearchParams};
}

const buildSearchParamsObject = (input) => {
    const result = {};

    for(const [key, value] of Object.entries(input || {}))
    {
        const clean = sanitizeValue(value, key);
        if(clean !== null) result[key] = clean;
    }

    return result;
}

function sanitizeValue(value, key) {
    if(value === null || value === undefined) return null;
    if(typeof value === "boolean") return String(value);
    if(typeof value === "number") return String(value);

    if(typeof value === "string")
    {
        if(value.trim() === "") return null;
        return value;
    }

    if (typeof value === "object")
    {
        try
        {
            const str = value.toString();

            if(!str || str === "[object Object]")
            {
                console.error(`[customSearchParams] Invalid object at key: ${key}`, value);
                return null;
            }

        return str;
        }
        catch(e)
        {
            console.error(`[customSearchParams] Cannot stringify key: ${key}`, value);
            return null;
        }
    }

    try
    {
        return String(value);
    }
    catch
    {
        console.error(`[customSearchParams] Unsupported value at key: ${key}`, value);
        return null;
    }
}